// ============================================
// 📱 APP: NVA (React App)
// 📄 FILE: src/components/home/HomeGuest.tsx
// 🔧 PURPOSE: La vista G della Home: l'ospite non è ancora entrato.
//
//             Props (HomeGuestProps = HomeViewProps, components/home/types):
//             - state: HomeState (qui sempre view 'guest': niente date);
//             - now: l'ora del clock della Home (useNow).
//             Login, chat e assistente da useHomeSession(); le finestre dei
//             servizi da useServiceDialogs(). Il pulsante flottante con
//             l'Assistente AI lo monta la Home (solo in questa vista).
//
//             Ordine (mockup Ospite):
//             1. il carosello con la riga del marchio sopra (benvenuto,
//                esplora, città, evento): al posto dell'intestazione;
//             2. la card "Hai già prenotato?" che risale sul carosello
//                (ACCEDI, il riquadro del portale esterno → check-in online,
//                PRENOTA), o "Check-in inviato · in attesa" se un check-in
//                partito da qui aspetta lo smistamento (guestClaimState);
//             3. i tre vantaggi;
//             4. "Con l'accesso" (ogni voce: login, poi la sua pagina);
//             5. Info utili (UsefulServices 'guest');
//             6. Scopri (DiscoverRail 'guest');
//             7. Offerte (SpecialOffers 'guest');
//             8. Intrattenimento, ULTIMO prima del footer.
// ============================================

import React from 'react';
import type { HomeViewProps } from './types';
import HomeHeroCarousel from './HomeHeroCarousel';
import GuestWelcomeCard from './GuestWelcomeCard';
import GuestPerks from './GuestPerks';
import LoginTeaser from './LoginTeaser';
import UsefulServices from './UsefulServices';
import DiscoverRail from './DiscoverRail';
import Entertainment from './Entertainment';
import HomeFooter from './HomeFooter';
import SpecialOffers from '../SpecialOffers';
import { useGuestClaimPending } from './guestClaimState';

export type HomeGuestProps = HomeViewProps;

const HomeGuest: React.FC<HomeGuestProps> = ({ now }) => {
  const claimPending = useGuestClaimPending();
  return (
    <>
      <HomeHeroCarousel now={now} />
      <GuestWelcomeCard claimPending={claimPending} />
      <GuestPerks />
      <LoginTeaser />
      <UsefulServices variant="guest" />
      <DiscoverRail variant="guest" />
      <SpecialOffers variant="guest" />
      <Entertainment />
      <HomeFooter />
    </>
  );
};

export default HomeGuest;
